var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email_725643",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.909,
    height: 24,
    viewBox: "0 0 34.909 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28966",
    "data-name": "Group 28966",
    transform: "translate(23.092 4.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28965",
    "data-name": "Group 28965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39852",
    "data-name": "Path 39852",
    d: "M339.392,152.682l11.817,7.471V144.9Z",
    transform: "translate(-339.392 -144.896)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28968",
    "data-name": "Group 28968",
    transform: "translate(0 4.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28967",
    "data-name": "Group 28967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39853",
    "data-name": "Path 39853",
    d: "M0,144.9v15.257l11.817-7.471Z",
    transform: "translate(0 -144.896)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28970",
    "data-name": "Group 28970",
    transform: "translate(0.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28969",
    "data-name": "Group 28969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39854",
    "data-name": "Path 39854",
    d: "M33.621,80H3.076A2.158,2.158,0,0,0,.96,81.864l17.389,11.5,17.389-11.5A2.158,2.158,0,0,0,33.621,80Z",
    transform: "translate(-0.96 -80)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28972",
    "data-name": "Group 28972",
    transform: "translate(0.07 13.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28971",
    "data-name": "Group 28971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39855",
    "data-name": "Path 39855",
    d: "M22.1,277.922l-3.087,2.042a1.092,1.092,0,0,1-1.2,0l-3.087-2.044-13.7,8.7a2.154,2.154,0,0,0,2.112,1.849H33.681a2.154,2.154,0,0,0,2.112-1.849Z",
    transform: "translate(-1.024 -277.92)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDashboardIcon);
export default __webpack_public_path__ + "static/media/email_dashboard_icon.2a8694c5293d4b99f11c1eebd4844ce0.svg";
export { ForwardRef as ReactComponent };